// export const apiUrl = 'https://sli-gmbh.fr-1.paas.massivegrid.net';
// export const apiUrl = "https://sli-gmbh.fr-1.paas.massivegrid.net";
// export const apiUrl = "http://sli.local";
export const apiUrl = "https://pim.sli-gmbh.at";
